import View from './view';

export default View.extend( {
    events: {
        'click .-intermediate-property--add-start'() {
            this.trigger( 'intermediate-property:add-start' );
        },

        'click .-terminal-property--add-start'() {
            this.trigger( 'terminal-property:add-start' );
        },
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/config.property.actions.js